import { createNumberArray, } from '../utils';
/**
 * Create a new matrix based on the size of the current one or by using specific dimensions.
 */
export function matrixCreateEmpty(options) {
    const { matrix, nbRows = matrix?.length || 1, nbColumns = matrix?.[0].length || 1, ArrayConstructor = Float64Array, } = options;
    const newMatrix = [];
    for (let row = 0; row < nbRows; row++) {
        newMatrix.push(createNumberArray(ArrayConstructor, nbColumns));
    }
    return newMatrix;
}
//# sourceMappingURL=matrixCreateEmpty.js.map